<template>
    <div>
        <el-alert
            v-if="!company.kyc_filled"
            show-icon
            type="warning">
            <span class="d-block mb-1 text-black">
                Account hasn't submitted KYC information yet.
            </span>
        </el-alert>
        <kyc-account-details
            ref="kycAccountDetails"
            :selected-company="company"
            :parse-status="parseStatus"
            :parse-status-value="parseStatusValue"
            :should-show-back-button="false"
            :is-loading-change-status="isLoadingChangeStatus"
            :is-loading-add-note="isLoadingAddNote"
            @change-status="changeStatus"
            @add-note="addNote"
        />
    </div>
</template>

<script>
import KycAccountDetails from './kyc-account-details'
import kycStatuses from "../../constants/compliance-kyc-statuses"

export default {
    name: 'KycAccountTab',

    components: {
        KycAccountDetails
    },

    props: {
        company: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            isLoadingChangeStatus: false,
            isLoadingAddNote: false,
            kycStatuses
        }
    },

    methods: {
        parseStatus (rowStatus) {
            const matchedStatus = this.kycStatuses.find(status => status.enumValue === rowStatus)

            return matchedStatus ? matchedStatus.label : ''
        },

        parseStatusValue (statusValue) {
            const matchedStatus = this.kycStatuses.find(status => status.enumValue === statusValue)

            return matchedStatus ? matchedStatus.value : ''
        },

        fetchData () {
          this.$refs?.kycAccountDetails?.getKycAccountReviewLogs()
          this.$refs?.kycAccountDetails?.setNoteFieldEmptyAndCloseDialog()
        },

        changeStatus (row, kyc_status, notes) {
            const params = {
                kyc_status,
                notes
            }

            this.isLoadingChangeStatus = true

            axios.patch(`/api/admin/kyc-signups/${this.company.id}`, params)
                .then(res => {
                    this.$message({
                        message: 'Status changed successfully',
                        type: 'success'
                    })

                    this.company.kyc_status = kyc_status

                    this.fetchData()
                })
                .catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.isLoadingChangeStatus = false
                })
        },

        addNote (row, notes) {
            const id = row.pre_signup_id || row.id
            const params = {
                notes
            }

            this.isLoadingAddNote = true

            axios.patch(`/api/admin/kyc-signups/${this.company.id}`, params)
                .then(res => {
                    this.$message({
                        message: 'Note added successfully',
                        type: 'success'
                    })

                    this.fetchData()
                })
                .catch(err => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.isLoadingAddNote = false
                })
        },
    }

}
</script>
